import React, { createContext, useContext, useState, useCallback } from 'react';
import { languages } from '../i18n';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem('lang') || 'en'; } catch { return 'en'; }
  });

  const changeLang = useCallback((code) => {
    setLang(code);
    try { localStorage.setItem('lang', code); } catch {}
  }, []);

  // Nested-key translation: t('common.save') or t('nav.dashboard')
  const t = useCallback((key) => {
    const dict = languages[lang] || languages.en;
    const parts = key.split('.');
    let val = dict;
    for (const p of parts) {
      if (val == null) break;
      val = val[p];
    }
    // Fallback to English
    if (val == null || typeof val === 'object') {
      let fb = languages.en;
      for (const p of parts) { if (fb == null) break; fb = fb[p]; }
      return typeof fb === 'string' ? fb : key;
    }
    return val;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t, translations: languages[lang] || languages.en }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}

// Convenience: just the translate function
export function useT() {
  return useLanguage().t;
}
